type MenuNode = {
  name: string,
  currentPage: true,
  active: true,
  contentLink: string,
  contentId: number,
  friendlyUrl: string,
  childrenLoaded: boolean,
  children: MenuNode[],
  hideFromTopMenu: boolean
}

class MenuService {

    /**
     * Get a navigation node
     * @param contentLinkId Id of the target node
     * @param currentPageId Current page Id, optionnal
     * @returns An object containing the node
     */
    getNavigationNode(contentLinkId: number = null, currentPageId: number = null): Promise<MenuNode> {
        return new Promise((res, rej) => {
            $.post("/api/navigation/GetNavigationNode",
                {
                    ContentLinkId: contentLinkId,
                    CurrentPageId: currentPageId
                }
            ).done(res).fail(rej);
        })
    }
}

export default new MenuService();
